/** The frame every icon is drawn in: a 24x24 stroked viewBox. */

import type { ParentComponent } from 'solid-js';
import styles from '../primitives/Icon.module.css';

export const Svg: ParentComponent = (props) => (
  <svg viewBox="0 0 24 24" class={styles.ico} aria-hidden="true">
    {props.children}
  </svg>
);
